/**
 * 转出成功页面
 */

import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import PageLayout from '@/components/PageLayout'
import CustomButton from '@/components/CustomButton'
import FixedBottom from '@/components/FixedBottom'

export default function WithdrawSuccess() {
  const { t } = useTranslation()
  const navigate = useNavigate()

  // 返回卡片主界面
  const handleBackToCard = useCallback(() => {
    navigate('/card', { replace: true })
  }, [navigate])

  return (
    <PageLayout>
      <div className="flex-1 flex flex-col items-center justify-center px-5 -mt-20">
        {/* 成功图标 */}
        <div className="w-20 h-20 rounded-full bg-[#E8F5E9] flex items-center justify-center mb-6">
          <div className="w-14 h-14 rounded-full bg-[#4CAF50] flex items-center justify-center">
            <img src="/images/card-v2/success-white.svg" alt="" className="w-8 h-8" />
          </div>
        </div>

        {/* 成功标题 */}
        <div className="text-xl font-semibold text-[#1D2129] mb-3">
          {t('转出已提交')}
        </div>

        {/* 成功描述 */}
        <div className="text-base text-[#86909C] text-center leading-relaxed px-6">
          {t('审核将在5-10分钟完成，可前往交易记录查看转出进度')}
        </div>
      </div>

      {/* 底部按钮 */}
      <FixedBottom>
        <CustomButton onClick={handleBackToCard}>
          {t('确定')}
        </CustomButton>
      </FixedBottom>
    </PageLayout>
  )
}

